export const employeeConstant = {
  GET_EMPLOYEE: "GET_EMPLOYEE",
  GET_ALL_EMPLOYEE: "GET_ALL_EMPLOYEE",
  EMPLOYEE_STATUS: "EMPLOYEE_STATUS",
  LOADER: "LOADERE",
  GET_FILTERED_EMPLOYEES: "GET_FILTERED_EMPLOYEES",
  RESET_SEARCH: "RESET_SEARCH",
  GET_ALL_MANAGER_EMPLOYEES: "GET_ALL_MANAGER_EMPLOYEES",
};
